var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "home_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.667 2.5 7.5v9.167a1.666 1.666 0 0 0 1.667 1.666h11.666a1.666 1.666 0 0 0 1.667-1.666V7.5L10 1.667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.333V10h5v8.333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgHome as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMTAgMS42NjY2M0wyLjUgNy40OTk5NlYxNi42NjY2QzIuNSAxNy4xMDg3IDIuNjc1NTkgMTcuNTMyNiAyLjk4ODE2IDE3Ljg0NTFDMy4zMDA3MiAxOC4xNTc3IDMuNzI0NjQgMTguMzMzMyA0LjE2NjY3IDE4LjMzMzNIMTUuODMzM0MxNi4yNzU0IDE4LjMzMzMgMTYuNjk5MyAxOC4xNTc3IDE3LjAxMTggMTcuODQ1MUMxNy4zMjQ0IDE3LjUzMjYgMTcuNSAxNy4xMDg3IDE3LjUgMTYuNjY2NlY3LjQ5OTk2TDEwIDEuNjY2NjNaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNNy41IDE4LjMzMzNWMTBIMTIuNVYxOC4zMzMzIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";